import { http } from "Utils/http";
import { Col, Button } from 'react-bootstrap';
import { TextButton, IconTextButton } from 'Components/Button';
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { store } from 'Store';
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { isInObject } from "Utils/utilityFunctions";
import { generateAccountStatusRpt } from "../UserAxiosFuncs";
import { ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { ICONS } from "Utils/icons";


const ListUserTable = ({ ...props }) => {

    const dispatch = useDispatch();
    const loginInfo = useSelector(state => state.loginInfo);
    const info = props.info;
    const isPSOAdmin = info.isPSOAdmin;
    const isPSOPPCAdmin = info.isPSOPPCAdmin;
    const allowEdit = info.allowEdit;
    let location = useLocation();

    const [sortColumn, setSortColumn] = useState({
        sortField: "firstName",
        sortDirection: "asc"
    });

    const [filter, setFilter] = useState(null);

    useEffect(() => {
        var passedData = location.state;
        //console.log("FILTER");
        //console.log(filter);
        //console.log(location);
        //console.log(passedData);

        if (isInObject("filter", passedData)) {
            //console.log("setFilter");
            setFilter(passedData.filter);
        }
        else {
            setFilter({
                startIndex: 0,
                entryPerPage: 10,
                sortingColumn: sortColumn.sortField,
                sortingOrder: sortColumn.sortDirection,
                searchTerm: ""
            });
        }
        //console.log(filter);
    }, [])

    const handleDateFormat = (time) => {
        if (time != null) {
            let date = new Date(time);
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let hour = date.getHours();
            let min = date.getMinutes();
            return (
                <div>
                    {month < 10 ? "0" + month : month}/
                    {day < 10 ? "0" + day : day}/
                    {year + " "}
                    {hour < 10 ? "0" + hour : hour}:
                    {min < 10 ? "0" + min : min}
                </div>
            )
        }
        else {
            return (
                <div>

                </div>
            )
        }

    }

    const handleOrgNameFormat = (row) => {
        var idText = "";
        if (row.orgPSOId != null) {
            idText = "(" + row.orgPSOId + ")";
        }
        return row.psoName + " " + idText;
    }

    const contactFormatter = (_value, row) => {
        if (row.userId === row.primaryContactUserId) return "POC";
        if (row.userId === row.ahrqCertifiedContactUserId) return "AO";
        return null;
    };

    const getTest = async (filter) => {
        var call = filter;

        //console.log("CALL");
        //console.log(call);
        var url = '/api/manage/user/getUsers';
        //const loginState = store.getState().loginInfo;

        return http.post(url, call, {
            headers: {
                "Authorization": "Bearer " + loginInfo.token
                //"Referrer-Policy": "strict-origin-when-cross-origin"
            }
        });
    }

    const getListCols = (selectedList, sortingInfo) => {
        const listUserColumns = [];

        const title = function ({ rowName }) {
            //TestTitle {0} test {1}
            //Params: rowName, "valuehere"
            return "Click the link to edit user " + rowName + ".";
        }

        const fullNameTitle = function ({ rowName }) {
            //console.log(rowName);
            return "Click the link to view user " + rowName + ".";
        }

        const userState = function ({ rowName }) {
            //console.log(rowName);
            //console.log(filter);
            //console.log(location.state);
            //console.log(location.state.datatableFilter);

            return {
                userId: rowName.userId,
                statusDesc: rowName.userStatusDesc,
                isPSOPPCAdmin: isPSOPPCAdmin,

                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        filter
                    },

                }
            };
        }

        listUserColumns.push(Datatable_Column({ name: "Full Name", columnName: ["firstName", "lastName"], concatColName: "fullName", selectedRows: selectedList, sortable: true, sortFieldNum: 4, isLink: true, linkData: { title: fullNameTitle, pathname: "/manage/viewUser", text: null, state: userState }, sortingInfo: sortingInfo }))
        //listOrganizationColumns.push(Datatable_Column({name:"Last Name", columnName:"lastName", selectedRows: selectedList, sortable:true, sortFieldNum:4}))
        listUserColumns.push(Datatable_Column({ name: "Email Address", columnName: "emailAddress", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))
        if (isPSOPPCAdmin == true) {
            listUserColumns.push(Datatable_Column({ name: "Organization", columnName: "psoName", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))
        }

        listUserColumns.push(Datatable_Column({ name: "User Status", columnName: "userStatusDesc", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))
        listUserColumns.push(Datatable_Column({ name: "Role", columnName: "roleName", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))
        if (isPSOPPCAdmin == true || isPSOAdmin == true) {
            listUserColumns.push(Datatable_Column({ name: "Contact Type", columnName: "contactType", selectedRows: selectedList, sortable: false, sortFieldNum: 4, sortingInfo: sortingInfo, formatFunction: contactFormatter }))
        }
        listUserColumns.push(Datatable_Column({ name: "Last Sign In", columnName: "loginDate", selectedRows: selectedList, sortable: true, sortFieldNum: 4, formatFunction: handleDateFormat, sortingInfo: sortingInfo }))

        if (isPSOPPCAdmin == true && allowEdit == true) {
            listUserColumns.push(Datatable_Column({ name: "Edit", columnName: "edit", selectedRows: selectedList, sortable: false, sortFieldNum: 4, isLink: true, linkData: { title: title, pathname: "/manage/editUser", text: "Edit", state: userState }, sortingInfo: sortingInfo }))
        }

        return listUserColumns;
    }

    const tableTitle = function () {
        return "PSOPPC Users";
    }

    const tableDescription = function () {
        return "Select a user to view detailed information.";
    }
    const [selectedCount, setSelectedCount] = useState(0);


    const handleCreatePopup = (e) => {
        props.setShowPopup(true);
    }
    // download account status report
    const handleFileDownload = async () => {
        const res = await generateAccountStatusRpt("Bearer " + loginInfo.token).catch((error) => {
            //console.log("error handleFileDownload()", error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        //console.log("after handleFileDownload", res);

        if (res?.status?.code === 1) {
            // get filename from the res content-disposition
            const fileName = res.data.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
            //console.log("after handleFileDownload filename", fileName);
            let url = window.URL.createObjectURL(res.data.data);
            let a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a); // append the element to the dom
            a.click();
            a.remove(); // afterwards, remove the element  
        } else {
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: res.data?.status?.text
            });
        }
    }

    return (
        <>

            {filter != null ?
                <DatatableBase
                    tableClassName="listUsersTable"
                    getData={getTest}
                    filter={filter}
                    setFilter={setFilter}

                    getListCols={getListCols}
                    setSelectedCount={setSelectedCount}
                    hasSelectableRows={false}
                    searchFieldText={"Search by name, email, PSO ID, organization, status, and role"}
                    datatableHeader={tableTitle()}
                    datatableDescription={tableDescription()}
                    sortingColumn={sortColumn.sortField}
                    sortingOrder={sortColumn.sortDirection}
                >
                    {
                        <>
                            <Col className="d-flex justify-content-end gap-4">
                                {
                                    isPSOPPCAdmin || isPSOAdmin
                                        ?
                                        <>
                                            {isPSOPPCAdmin &&
                                              <TextButton className="ms-auto " title="Create new user for an organization" /*href={"users/createuser"}*/ onClick={handleCreatePopup} variant="normal" content={"Create New User"} />
                                            }
                                            <IconTextButton
                                                className="reverse"
                                                icon={ICONS.download}
                                                onClick={handleFileDownload}
                                                variant="normal"
                                                content={"Account Status Report"}
                                            />
                                        </>
                                        : null
                                }

                            </Col>
                        </>
                    }

                </DatatableBase>
                : null
            }
        </>
    );
}

export default ListUserTable;